import BrandLogo from "@/components/feature/BrandLogo";
import { BRAND_NAME } from "@/lib/constants";

export default function BrandLoader({ label = "Cargando..." }: { label?: string }) {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-background-50 px-6">
      <div className="animate-scale-in">
        <BrandLogo size={110} />
      </div>
      <div className="flex flex-col items-center gap-3">
        <div className="flex h-6 w-6 items-center justify-center">
          <i className="ri-loader-4-line animate-spin text-xl text-primary-500"></i>
        </div>
        <p className="text-sm font-medium tracking-wide text-foreground-500">{label}</p>
      </div>
      <p className="font-heading text-xs font-semibold uppercase tracking-[0.3em] text-foreground-300">
        {BRAND_NAME}
      </p>
    </div>
  );
}